import React from 'react';

const FastCashView = () => {
  return (
    <div className="fastcash-view">
      <div className="fastcash-header">
        <h2>FastCASH™</h2>
        <p className="fastcash-subtitle">Cash Intelligence Diagnostic Tool</p>
      </div>
      <div className="fastcash-iframe-container">
        <iframe
          src="https://sme-advisory-hub.preview.emergentagent.com"
          title="FastCASH™ - Recovery Intelligence"
          width="100%"
          height="850px"
          style={{ border: 'none' }}
          allow="clipboard-write"
        />
      </div>
    </div>
  );
};

export default FastCashView;
